import { Route, Routes } from "react-router-dom";
import { ROUTEPATHS } from "../../libs";
import { ManageLibrariesPage } from "./manage-controls";
import { ManageTemplatePage } from "./manage-templates";
import { Playlists } from "../../components/manage-template-components/Playlists";
import { PlaylistDetail } from "../../components/manage-template-components/Playlists/playlist-detail";
import { VideoOnDemand } from "../../components/manage-template-components/video-on-demand";
import { LiveStreams } from "../../components/manage-template-components/live-streams";
import { EmbedCode } from "./embed-code";
import { LibraryOutletsPage } from "./library-outlets";
import { ManageProfilesPage } from "./manage-profiles";
import { ManageVersionsPage } from "./manage-versions";
import { ManageBlocksPage } from "./manage-blocks";


export const RouteManageLibrariesContainer: React.FC = () => {
  return (
    <Routes>
      <Route path={`/${ROUTEPATHS.MANAGE_CONTROLS}`} element={<ManageLibrariesPage />} />
      <Route path={ROUTEPATHS.MANAGE_TEMPLATE_PLAYLISTS} element={<Playlists />} />
      <Route path={ROUTEPATHS.MANAGE_TEMPLATE_PLAYLIST_DETAIL} element={<PlaylistDetail />} />
      <Route path={ROUTEPATHS.MANAGE_TEMPLATE_VOD} element={<VideoOnDemand />} />
      <Route path={ROUTEPATHS.MANAGE_TEMPLATE_LIVE_STREAMS} element={<LiveStreams />} />
      <Route path={`/${ROUTEPATHS.MANAGE_TEMPLATE}`} element={<ManageTemplatePage />} />
      <Route path={ROUTEPATHS.LIBRARY_OUTLETS} element={<LibraryOutletsPage />} />
      <Route path={ROUTEPATHS.EMBED_CODE} element={<EmbedCode />} />
      <Route path={`/${ROUTEPATHS.MANAGE_PROFILES}`} element={<ManageProfilesPage />} />
      <Route path={ROUTEPATHS.MANAGE_PROFILE_VERSIONS} element={<ManageVersionsPage />} />
      <Route path={ROUTEPATHS.MANAGE_VERSION_BLOCKS} element={<ManageBlocksPage />} />
    </Routes>
  );
};
